import { lazy } from 'react'
import { Outlet, RouteObject } from 'react-router'

const HeadcountReportDownloadPage = lazy(() => import('@/pages/headcount/headcount-report-download.tsx'))
const HeadcountChartsPage = lazy(() => import('@/pages/headcount/headcount-charts'))


export const headcountRoutes: RouteObject = {
  path: 'headcount',
  element: <Outlet />,
  children: [
    { index: true, element: <HeadcountReportDownloadPage /> },
    { path: 'charts', element: <HeadcountChartsPage /> },
  ],
}